import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { api } from '@/api/http';
import { tokenStore } from '@/lib/auth';

/**
 * Rota pública consumida pelo botão "Reagendar" da confirmação WhatsApp.
 * Troca o magic-link (token assinado HMAC) por tokens JWT no backend e
 * redireciona pro detalhe da sessão com o modal de reagendamento aberto.
 *
 * Pública — qualquer pessoa com o link autentica naquela sessão específica.
 * Segurança: token tem TTL curto (24h, F3) e é amarrado a sessionId+clientId.
 */
export const Route = createFileRoute('/sessao/abrir/$token')({
  component: MagicOpenPage,
});

function MagicOpenPage() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api
          .post('auth/magic/session', { json: { token } })
          .json<{ accessToken: string; refreshToken: string; sessionId: string }>();
        if (cancelled) return;
        tokenStore.set(res.accessToken, res.refreshToken);
        navigate({
          to: '/dashboard/sessoes/$id',
          params: { id: res.sessionId },
          search: { reschedule: 1 },
        });
      } catch {
        if (!cancelled) setError('Link expirado ou inválido. Faça login para acessar sua sessão.');
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-sm text-center space-y-3">
          <p className="text-sm text-slate-700">{error}</p>
          <a href="/login" className="inline-block text-sm font-medium text-teal-600 hover:underline">
            Ir para o login
          </a>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-slate-400">
      Abrindo sua sessão…
    </div>
  );
}
